// src/components/settings/team-defaults-tab.jsx
import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "react-toastify";
import { useStateValue } from "../../context/StateProvider";
import { actionType } from "../../context/reducer";
import {
  saveTeamDefaults,
  TEAM_DEFAULTS_FALLBACK,
} from "../../utils/teamDefaults";

const FIELDS = [
  { key: "titleCompany",     label: "Our Title Company",       type: "text" },
  { key: "titleCloserName",  label: "Our Title Closer Name",   type: "text" },
  { key: "titleCloserEmail", label: "Our Title Closer Email",  type: "email" },
  { key: "titleCloserPhone", label: "Our Title Closer Phone",  type: "tel" },
  { key: "brokerAdminFee",   label: "Broker Admin Fee ($)",    type: "number" },
];

export default function TeamDefaultsTab() {
  const [{ user, teamDefaults }, dispatch] = useStateValue();
  const [draft, setDraft] = useState(teamDefaults || TEAM_DEFAULTS_FALLBACK);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (teamDefaults) setDraft(teamDefaults);
  }, [teamDefaults]);

  const update = (key, value) => setDraft((d) => ({ ...d, [key]: value }));

  const onSave = async () => {
    setSaving(true);
    try {
      const payload = {
        ...draft,
        brokerAdminFee: Number(draft.brokerAdminFee) || 0,
      };
      await saveTeamDefaults(payload, user?.id);
      dispatch({ type: actionType.SET_TEAM_DEFAULTS, payload });
      toast.success("Team Defaults Saved");
    } catch (err) {
      console.error("saveTeamDefaults failed:", err);
      toast.error("Could not save. Try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-xl space-y-4">
      <div>
        <h3 className="text-lg font-semibold text-slate-900">Team Defaults</h3>
        <p className="text-sm text-slate-500 mt-1">
          These values pre-fill the post-acceptance emails (Client and Title) so
          your team doesn't re-enter them per deal. You can override the broker
          admin fee on an individual deal when sending.
        </p>
      </div>

      {FIELDS.map((f) => (
        <div key={f.key}>
          <label className="block text-xs font-semibold text-slate-600 mb-1">
            {f.label}
          </label>
          <input
            type={f.type}
            value={draft[f.key] ?? ""}
            onChange={(e) => update(f.key, e.target.value)}
            className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm"
          />
        </div>
      ))}

      <div className="pt-2">
        <button
          onClick={onSave}
          disabled={saving}
          className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-semibold rounded-md bg-indigo-600 hover:bg-indigo-700 text-white disabled:opacity-50"
        >
          {saving ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />}
          {saving ? "Saving…" : "Save"}
        </button>
      </div>
    </div>
  );
}
